// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Y9d3","content":"styles_content__3Iuai","checkbox":"styles_checkbox__FFv6V","checkboxLabel":"styles_checkboxLabel__1RVnS"};